import get from 'lodash/get'
import sumBy from 'lodash/sumBy'

export default class CarProgress {
  constructor() {
    this.config = {}
    this.pageProgress = {}
    this.sectionProgress = {}
    this.fieldProgress = {}
  }

  setup(config) {
    this.config = config
  }

  update(car) {
    this.calculateFieldProgress(car)
    this.calculateSectionProgress()
    this.calculatePageProgress()
  }

  forPage(key) {
    if (!this.pageProgress[key]) {
      return 0
    }

    return this.pageProgress[key].progress
  }

  forSection(key) {
    if (!this.sectionProgress[key]) {
      return 0
    }

    return this.sectionProgress[key].progress
  }

  calculateFieldProgress(car) {
    Object.entries(this.config).forEach(([page, sections]) => {
      Object.entries(sections).forEach(([section, fields]) => {
        if (typeof fields === 'function') {
          this.fieldProgress = {
            ...this.fieldProgress,
            [`${page}.${section}`]: fields
          }
        } else {
          Object.entries(fields).forEach(([field, validator]) => {
            const fieldKey = `${page}.${section}.${field}`
            const fieldValue = get(car, field)

            let validationResult = false

            if (fieldValue === undefined) {
              validationResult = false
            } else if (typeof validator === 'function') {
              validationResult = validator(fieldValue)
            } else {
              validationResult = fieldValue !== null && fieldValue !== ''
            }

            this.fieldProgress = {
              ...this.fieldProgress,
              [fieldKey]: validationResult
            }
          })
        }
      })
    })
  }

  calculateSectionProgress() {
    Object.entries(this.config).forEach(([page, sections]) => {
      Object.entries(sections).forEach(([section]) => {
        const sectionKey = `${page}.${section}`
        const fields = Object.entries(this.fieldProgress).filter(([field]) => field.startsWith(sectionKey))
        let fieldCount = fields.length
        let validFieldCount = 0
        let invalidFieldCount = 0

        if (typeof this.fieldProgress[sectionKey] === 'function') {
          const [current, total] = this.fieldProgress[sectionKey]()

          fieldCount = total
          validFieldCount = current
          invalidFieldCount = total - current
        } else {
          validFieldCount = fields.filter(([, result]) => result).length
          invalidFieldCount = fields.filter(([, result]) => !result).length
        }

        this.sectionProgress[sectionKey] = {
          fieldCount,
          validFieldCount,
          invalidFieldCount
        }
        this.sectionProgress[sectionKey] = {
          ...this.sectionProgress[sectionKey],
          progress: Math.floor((this.sectionProgress[sectionKey].validFieldCount / this.sectionProgress[sectionKey].fieldCount) * 100)
        }
      })
    })
  }

  calculatePageProgress() {
    Object.entries(this.config).forEach(([page]) => {
      const sections = Object.entries(this.sectionProgress).filter(([section]) => section.startsWith(page))
      const summedProgress = sumBy(sections, ([, result]) => result.progress)

      this.pageProgress[page] = {
        sectionCount: sections.length,
        validSectionCount: sections.filter(([, result]) => result.progress === 100).length,
        invalidSectionCount: sections.filter(([, result]) => result.progress !== 100).length
      }

      this.pageProgress[page] = {
        ...this.pageProgress[page],
        progress: Math.floor(summedProgress / this.pageProgress[page].sectionCount) || 0
      }
    })
  }
}
